import { EditOrganisationQuestionnairesForm } from '../components/EditOrganisationQuestionnairesForm';

export const EditOrganisationQuestionnairesContainer = () => <EditOrganisationQuestionnairesForm />;
